import { ControlConstants } from "../../control/constant/ControlConstants";
import { ButtonProperties } from "../../control/properties/ButtonProperties";
import { SpriteProperties } from "../../control/properties/SpriteProperties";
import { TextFieldProperties } from "../../control/properties/TextFieldProperties";
import { RealityCheckNoOptionsDialog } from "../display/RealityCheckNoOptionsDialog";
import { CommonFontStyle } from "../style/CommonFontStyle";
import { CommonStyle } from "../style/CommonStyle";
import { AbstractMessageDialogProperties } from "./AbstractMessageDialogProperties";
/**
 * AbstractRealityCheckNoOptionsDialogProperties.ts=
 */
export class AbstractRealityCheckNoOptionsDialogProperties extends AbstractMessageDialogProperties {
    equals(other) {
        return super.equals(other) &&
            this.timeFieldProperties.equals(other.timeFieldProperties);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundProperties = new SpriteProperties(CommonStyle.MESSAGE_DIALOG_0, CommonStyle.MODULE);
        this.timeFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_MESSAGE, null, null, ControlConstants.CENTER);
        this.confirmButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_1, CommonStyle.MODULE);
        this.confirmButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_BUTTON_1);
    }
    getClass() {
        return RealityCheckNoOptionsDialog;
    }
    getClassName() {
        return "RealityCheckNoOptionsDialog";
    }
}
//# sourceMappingURL=AbstractRealityCheckNoOptionsDialogProperties.js.map